import AppProvider from "./provider";

function App() {
  return <AppProvider />;
}

export default App;
